var $10556a59bf2ddefc$exports = {};
$10556a59bf2ddefc$exports = {
  "backButton": args => "N\xE1vrat na ".concat(args.prevMenuButton),
  "moreActions": "Dal\u0161\xED akce",
  "unavailable": "Nen\xED k dispozici, rozbalen\xEDm zobraz\xEDte podrobnosti"
};
export { $10556a59bf2ddefc$exports as default };